import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Article } from 'functions/src/types/firestore/Game/Article';
import { GradientTypography } from '../gradients/GradientTypography';
import { ArticleCard } from './ArticleListItem';
import { FlatList } from './FlatList';
import { useMobile } from 'src/hooks/useMobile';
import { ArticleCarouselMobile } from './ArticleCarouselMobile';

export type ArticlesListProps = {
  articles: Article<Date>[];
};

export function ArticlesList({ articles }: ArticlesListProps) {
  const theme = useTheme();
  const isMobile = useMobile();
  return (
    <Box
      sx={{
        px: 4,
        pb: 4,
        width: '100%',
      }}
    >
      <GradientTypography
        variant="h5"
        sx={{
          marginBottom: 2,
          marginLeft: '10px',
          textTransform: 'uppercase',
        }}
        gradientColor="primary.vertical"
      >
        Articles
      </GradientTypography>

      {!isMobile ? (
        <Box sx={theme.panels[3]}>
          <Box
            sx={{
              background: theme.palette.background.elevation[2],
              borderRadius: '10px',
              maxHeight: '1000px',
              height: 'auto',
              overflowY: 'auto',
            }}
          >
            <FlatList
              data={articles.sort((a, b) => {
                return Number(b.date) - Number(a.date);
              })}
              keyExtractor={({ title }) => {
                return title;
              }}
              renderComponent={(params) => {
                return <ArticleCard {...params} />;
              }}
              divider
              showDividerOnLastItem={false}
            />
          </Box>
        </Box>
      ) : (
        <ArticleCarouselMobile articles={articles} />
      )}
    </Box>
  );
}
